import { render } from "./CoachLeave.vue?vue&type=template&id=7073a71d&scoped=true"
import script from "./CoachLeave.vue?vue&type=script&lang=js"
export * from "./CoachLeave.vue?vue&type=script&lang=js"

import "./CoachLeave.vue?vue&type=style&index=0&id=7073a71d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7073a71d"]])

export default __exports__